var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:['container d-flex align-items-center justify-content-center', _vm.paddingClasses]},[_c('div',{class:['loader', _vm.paddingClasses]},[_c('div',{staticClass:"loader__item"}),_c('div',{staticClass:"loader__item"}),_c('div',{staticClass:"loader__item"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }